import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { ReasonForFailureService } from "./service/reason-for-failure.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute, Params } from "@angular/router";
import { CommonService } from "../../../../shared/services";
addMore(Highcharts);

@Component({
  selector: "widget-inward-reason-for-failure",
  templateUrl: "./widget-inward-reason-for-failure.component.html",
  styleUrls: ["./widget-inward-reason-for-failure.component.scss"],
  providers: [ReasonForFailureService]
})
export class WidgetInwardReasonForFailureComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;

  dropdownItems = ["All"];
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  ErrMsg;
  mockChart = null;
  Alldata;

  constructor(
    private translateService: TranslateService,
    private dataService: ReasonForFailureService,
    private commonService: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngAfterViewInit() {
   
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
     
    }
  }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS))
    this.translateService
      .get("PERFORMANCE.DELIVERY.REASON_FOR_FAILURE")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
      this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
        if (Object.keys(params).length) {
          this.FILTERS = this.commonService.getFiltersParams(params, this.FILTERS);
          this.getReasonForFailureData();
        } else {
          this.FILTERS=JSON.parse(JSON.stringify(intiFilter));
          this.getReasonForFailureData();
        }
      })
  }

  getReasonForFailureData() {
    this.errorMessage = "";
    this.chartOptions = null;
    this.mockChart = null;
    this.dataService
      .getReasonForFailureData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData.series.length) {
            chartData.series.map(data => {
              this.dropdownItems.push(data[0]);
            });
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
            this.Alldata = chartData;
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        err => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  public dropdownChange(value: any): void {
    if (value !== "All") {
      const newCahrdata = { series: [], total: this.Alldata.total };
      const filter = this.Alldata.series.filter(data => data[0] === value);
      newCahrdata.series = filter;
      this.chartOptions = this.dataService.createChart(
        newCahrdata,
        this.OPTIONS
      );
    } else {
      this.chartOptions = this.dataService.createChart(
        this.Alldata,
        this.OPTIONS
      );
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
